import axios from 'axios';

export default function (context, {data, cb}) {
    context.state.loading = true;
    let url = '/tourclient/payment/bankStatementList?';
    for (let k in data) {
        url += k + '=' + data[k] + '&'
    }
    url += '_' + new Date().getTime();
    axios({
        method: 'get',
        url,
        data: data,
        requestId: '/tourclient/payment/bankStatementList'
    }).then(({data}) => {
        context.commit('set', data);
        if (cb) cb(data);
    }).catch(e => {
        context.state.loading = false;
        context.dispatch('error', e, {root: true});
    })
}